import React, { useEffect, useState } from "react";
import { findDOMNode } from "react-dom";
const ownerDocument = (node) => (node && node.ownerDocument) || document;
const isDescendant = (el, target) => {
    if (target !== null && target.parentNode) {
        return el === target || isDescendant(el, target.parentNode);
    }
    return false;
};
/**
 * Listen for pointerup events outside of the component children.
 */
const ClickAwayListener = ({ onClickAway, children, 
/** jsdom can't see pointerup */
eventType = "pointerup", }) => {
    const [ref, _setRef] = useState(undefined);
    /**
     * @description addEventListener to owner document
     * @returns {()=> any} Unsubscribe
     */
    function subscribe(ref) {
        const owner = ownerDocument(ref);
        /**
         * Handle Event
         * @param event
         */
        const handle = (event) => {
            if (event.defaultPrevented)
                return;
            const el = findDOMNode(ref);
            const doc = ownerDocument(el);
            if (doc &&
                doc.documentElement &&
                doc.documentElement.contains(event.target) &&
                !isDescendant(el, event.target)) {
                onClickAway(event);
            }
        };
        owner.addEventListener(eventType, handle);
        /** Unsubscribe */
        return () => owner.removeEventListener(eventType, handle);
    }
    /** subscribe/unsubscibe on e/render */
    useEffect(() => (ref && subscribe(ref)) || undefined);
    const onlyChildren = React.Children.only(children);
    if (!React.isValidElement(onlyChildren)) {
        console.warn("Children: !isValidElement: ", onlyChildren);
        return null;
    }
    return React.cloneElement(onlyChildren, {
        ...onlyChildren.props,
        /**
         * set local ref and bubble up ....
         * @param value
         */
        ref: function setRef(value) {
            _setRef(value);
            if (hasRef(onlyChildren))
                onlyChildren.ref(value);
        },
    });
};
function hasRef(x) {
    return x && typeof x.ref === "function";
}
export default ClickAwayListener;
//# sourceMappingURL=index.js.map